export const consoleColors = {
  sidebar: "#0a0a0a",
  ink: "#111111",
  muted: "#5c6570",
  line: "#e2e8ef",
  page: "#f3f6f9",
  accent: "#21a7ec",
  accentHover: "#1788c9",
  gold: "#21a7ec",
  navText: "#c5ccd4",
  navMuted: "#8b949e",
  navActive: "rgba(33,167,236,0.32)",
  pageBar: "rgba(243,246,249,0.92)",
};

export const gridSx = {
  border: 0,
  background: "#fff",
  "& .MuiDataGrid-columnHeaders": { background: "#f7fafc", borderBottom: `1px solid ${consoleColors.line}` },
  "& .MuiDataGrid-columnHeaderTitle": { fontWeight: 650, fontSize: 13, color: "#3a424a" },
  "& .MuiDataGrid-cell": { fontSize: 13.5, color: consoleColors.ink, borderColor: "#eef2f6" },
  "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within, & .MuiDataGrid-columnHeader:focus": { outline: "none" },
  "& .MuiDataGrid-row:hover": { background: "#f7fafc" },
  "& .MuiDataGrid-footerContainer": { borderTop: `1px solid ${consoleColors.line}` },
};

export function headingCase(value) {
  return String(value || "").replace(/(^|[\s\-/])([a-z])/g, (_, sep, letter) => `${sep}${letter.toUpperCase()}`);
}

export const primaryButtonSx = {
  background: consoleColors.accent,
  color: "#fff",
  textTransform: "none",
  fontWeight: 650,
  boxShadow: "none",
  "&:hover": { background: consoleColors.accentHover, boxShadow: "none" },
};
